'use strict'

var Marionette = require('marionette')
var App = require('app')
var MapModule = require('src/common/map')


var mapView = Marionette.View.extend({
  template: require('./templates/map.html'),
  triggers: {
    'click .js-toggle-list': 'toggle:list',
    'click .js-toggle-map': 'toggle:map'
  },
  modelEvents: {
    'change': 'updateMap'
  },
  initialize: function () {
    var bindedFunction = _.bind(this.updateMap, this)
    this.throttledUpdateMap = _.throttle(bindedFunction, 3000)

    var self = this

    this.listenTo(this.model, 'request', function () {
      self.el.classList.add('loading')
    })

    this.listenTo(this.model, 'sync add remove', function () {
      setTimeout(function () {
        self.el.classList.remove('loading')
      }, 500)

      self.el.querySelector('.result-header__status .label').innerHTML = 'Your filter returned ' + this.model.get('total') + ' results.'
    })
  },
  onRender: function () {
    this.el.querySelector('.result-header__status .label').innerHTML = 'Your filter returned ' + this.model.get('total') + ' results.'
  },
  collectionToGeoJson: function (collection) {
    var geojson = []
    collection.each(function (model) {
      var location = model.get('geoLocation')
      // ignore markers which are place at 0,0
      if (location[0] === 0 && location[1] === 0) return false
      var feature = {
        'type': 'Feature',
        'properties': {
          'name': model.get('name'),
          'id': model.get('_id'),
          'type': model.get('type'),
          'online': model.get('online'),
          'error': model.get('error'),
          'model': model
        },
        'geometry': {
          'type': 'Point',
          'coordinates': [
            location[1],
            location[0]
          ]
        }
      }

      geojson.push(feature)
    })

    return geojson
  },
  updateMap: function (options) {

    options = Object.assign({
      reset:true
    }, options)

    var geojson = this.model.get('data')

    if (!geojson) return;

    this.editMap.setGeoJson(geojson)
    if (options.reset) this.editMap.zoomToFitAll()

  },
  onDestroy: function () {
  },
  onDomRefresh: function () {
    console.log('refresh')
    var self = this

    // map
    this.editMap = new MapModule({
      'container': 'map',
      'styleToggle': true,
      'location': [0, 0]
    })
   self.throttledUpdateMap()
    
  }

})
module.exports.layout = mapView



// WEBPACK FOOTER //
// ./js/modules/devices/map/view.js